module.exports = __webpack_public_path__ + "0aa3dbf1f871c96ef79f7c4f447e3417.png";